// dialog.js
import React from 'react';
import { createRoot } from 'react-dom/client';
import { DialogConfirm } from '@/components/modules/DialogConfirm';
import { DialogDetail } from '@/components/modules/DialogDetail';

export const dialog = {
  confirm: ({
    title,
    subtitle,
    icon,
    confirmText,
    cancelText,
    confirmButtonClass,
    cancelButtonClass,
    onConfirm = () => {},
    onCancel = () => {},
    content,
  }) => {
    const container = document.createElement('div');
    document.body.appendChild(container);
    const root = createRoot(container);

    const cleanup = () => {
      setTimeout(() => {
        root.unmount();
        container.remove();
      }, 800);
    };

    root.render(
      <DialogConfirm
        title={title}
        subtitle={subtitle}
        icon={icon}
        confirmText={confirmText}
        cancelText={cancelText}
        confirmButtonClass={confirmButtonClass}
        cancelButtonClass={cancelButtonClass}
        confirmAction={() => {
          onConfirm();
          cleanup();
        }}
        cancelAction={() => {
          onCancel();
          cleanup();
        }}
        onClose={cleanup}
      >
        {content}
      </DialogConfirm>,
    );
  },
  
  detail: ({
    title,
    subtitle,
    icon,
    confirmText,
    cancelText,
    confirmButtonClass,
    cancelButtonClass,
    onConfirm = () => {},
    onCancel = () => {},
    content,
  }) => {
    const container = document.createElement('div');
    document.body.appendChild(container);
    const root = createRoot(container);

    const cleanup = () => {
      setTimeout(() => {
        root.unmount();
        container.remove();
      }, 800);
    };

    root.render(
      <DialogDetail
        title={title}
        subtitle={subtitle}
        icon={icon}
        confirmText={confirmText}
        cancelText={cancelText}
        confirmButtonClass={confirmButtonClass}
        cancelButtonClass={cancelButtonClass}
        confirmAction={() => {
          onConfirm();
          cleanup();
        }}
        cancelAction={() => {
          onCancel();
          cleanup();
        }}
        onClose={cleanup}
        content={content}
      >
      </DialogDetail>,
    );
  },
};
